import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { Content, Header, Sidebar } from "@/components";
import { useAuth, useSidebar } from "@/context";

export function ProtectedRoute() {
  const { isOpen, close } = useSidebar();
  const { auth } = useAuth();
  const location = useLocation();

  React.useLayoutEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
    };
  }, []);

  React.useEffect(() => {
    // Evitar UI travada por pointer-events/inert em navegações
    document.body.style.pointerEvents = "auto";
    document.documentElement.style.pointerEvents = "auto";
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.style.pointerEvents = "auto";
      rootElement.removeAttribute("aria-hidden");
      rootElement.removeAttribute("inert");
    }

    // Garantir que overlays globais não fiquem ativos após navegação
    const overlaySelectors = [
      '[data-slot="dialog-overlay"]',
      '[data-slot="sheet-overlay"]',
      '[data-slot="drawer-overlay"]',
      '[data-slot="alert-dialog-overlay"]',
    ];
    overlaySelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => {
        (node as HTMLElement).style.pointerEvents = "none";
        (node as HTMLElement).style.display = "none";
      });
    });
  }, [location.pathname]);

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return (
    <div className="flex w-full min-h-screen h-screen overflow-hidden">
      <div className="flex flex-col w-full h-full overflow-hidden">
        <Header />
        <div className="flex flex-row flex-1 w-full min-h-0 overflow-hidden">
          <Sidebar />
          <Content>
            <Outlet />
          </Content>
        </div>
      </div>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={close}
        />
      )}
    </div>
  );
}
